var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfidence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00305f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1339.4,
    cy: 698.8,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(396.9 1879.5) rotate(-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1235.1,
    cy: 718.7,
    rx: 17.2,
    ry: 25,
    transform: "translate(-4.9 1429) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M790.7,1140.8c-53.5,0-103.9-19.5-141.9-54.9s-59.9-83.9-59.9-135.1V876.9a88.4,88.4,0,0,1,23.7-60A96.2,96.2,0,0,1,670.2,787a868.5,868.5,0,0,1,241,0,95.9,95.9,0,0,1,57.6,29.9,88.4,88.4,0,0,1,23.7,60v73.9c0,51.2-21.2,99.1-59.8,135.1S844.2,1140.8,790.7,1140.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1259.3,1140.8c-53.5,0-103.9-19.5-142-54.9s-59.8-83.9-59.8-135.1V876.9a88.4,88.4,0,0,1,23.7-60,95.9,95.9,0,0,1,57.6-29.9,868.5,868.5,0,0,1,241,0,96.2,96.2,0,0,1,57.6,29.9,88.4,88.4,0,0,1,23.7,60v73.9c0,51.2-21.3,99.1-59.9,135.1S1312.8,1140.8,1259.3,1140.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M630.5,874.6a28.4,28.4,0,0,1-7.6-1L465.7,832.3a30,30,0,0,1,15.2-58l157.2,41.3a30,30,0,0,1-7.6,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1419.5,874.6a30,30,0,0,1-7.6-59l157.2-41.3a30,30,0,1,1,15.2,58l-157.2,41.3A28.4,28.4,0,0,1,1419.5,874.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M945.8,1372.9a156.3,156.3,0,0,1-47.1-7.3c-84.6-26.4-132.6-116.8-134.6-120.6a30,30,0,0,1,53.2-27.8c.4.7,20.3,37.8,54.1,65.7,41.4,34,83.4,39,128.5,15.3a30,30,0,1,1,28,53.1C1000.5,1365.7,973,1372.9,945.8,1372.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M952.6,870.3a25.7,25.7,0,0,1-12.5-48.2c27.8-15.4,55.1-23.4,81.2-23.8,28.3-.5,55.4,8,80.6,25a25.7,25.7,0,0,1-28.8,42.6c-32.6-22.1-66.9-21.7-108,1.1A25.7,25.7,0,0,1,952.6,870.3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidence);
export default __webpack_public_path__ + "static/media/confidence.9a235a4d5995fccf262ff7733ab0ad33.svg";
export { ForwardRef as ReactComponent };